module.exports = global.config = {
    patients: { 
        totalPatients: 0,
        newPatients: 0,
        diagnosisPending: 0,
        predictionMade: 0
    },
    patientId: '',
    apiPath: 'http://172.17.85.23:8081/'
}